import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPhoneAlt, FaHandshake, FaRegEnvelope, FaSms, FaTrash, FaLayerGroup } from 'react-icons/fa';
import { FaWhatsapp, FaPencilAlt, FaFileAlt, FaMoneyBillWave, FaUser, FaTty } from 'react-icons/fa';
import { FaChevronCircleLeft, FaChevronCircleRight, FaClipboard, FaClock } from 'react-icons/fa';
import Select from "react-select";

import LeadAPI from '../../api/LeadAPI';
import ContactAPI from '../../api/ContactAPI';
import ApiUiController from '../../controller/ApiUiController';
import ViewController from '../../controller/ViewController';

import CallPopup from '../call/CallPopup';
import MeetingPopup from '../meeting/MeetingPopup';
import DocumentPopup from '../meeting/DocumentPopup';
import SmsPopup from '../sms/SmsPopup';
import EmailPopup from '../email/EmailPopup';
import WhatsAppPopup from '../whatsapp/WhatsAppPopup';
import LeadContactPopup from '../contact/LeadContactPopup';
import CloudCallPopup from '../call/CloudCallPopup';
import NotePopup from '../note/NotePopup';

import InnerCallList from '../call/InnerCallList';
import InnerMeetingList from '../meeting/InnerMeetingList';
import InnerSmsList from '../sms/InnerSmsList';
import InnerWhatsAppList from '../whatsapp/InnerWhatsAppList';
import InnerNoteList from '../note/InnerNoteList';
import InnerEmailList from '../email/InnerEmailList';
import InnerSalesOrderList from '../sales_order/InnerSalesOrderList';
import InnerContactList from '../contact/InnerContactList';

import LeadDetails from './LeadDetails';
import LeadInformation from './LeadInformation';

import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';

import './LeadPreview.css';
import PropertyDocTable from '../document/PropertyDocTable';
import RestrictedAccess from '../RestrictedAccess';

class LeadPreview extends React.Component {

  constructor(props) {
    super(props);

    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
    this.id = parseInt(props.match.params.leadId);

    const query = new URLSearchParams(props.location.search);
    this.iItem = query.get('indx') ? parseInt(query.get('indx')) : 0;
    this.lItem = query.get('size') ? parseInt(query.get('size')) : 0;
    const isNext = this.iItem !== 0 && this.lItem !== 0;

    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/preview'));

    this.editLink = `${this.base}/add-edit/${this.id}`
      + `${isNext ? `?indx=${this.iItem}&size=${this.lItem}` : ''}`;

    this.state = {
      inApiCall: this.id !== 0, popup: null, note: null,
      call: null, meeting: null, document: null, email: 0, sms: 0, whatsApp: 0, contacts: []
    };

    this.Restrcited = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.CallList = Util.isAllow(this.models.call.permission, Const.PermView);
    this.CallAdd = Util.isAllow(this.models.call.permission, Const.PermAdd);

    this.CallUpdate = Util.isAllow(this.models.call.permission, Const.PermUpdate);

    this.MeetList = Util.isAllow(this.models.meeting.permission, Const.PermView);
    this.MeetAdd = Util.isAllow(this.models.meeting.permission, Const.PermAdd);
    this.MeetUpdate = Util.isAllow(this.models.meeting.permission, Const.PermUpdate);

    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.SmsList = Util.isAllow(this.models.sms.permission, Const.PermView);
    this.SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);

    this.WhatsAppList = Util.isAllow(this.models.whatsapp.permission, Const.PermView);
    this.WhatsAppAdd = Util.isAllow(this.models.whatsapp.permission, Const.PermAdd);

    this.NoteList = Util.isAllow(this.models.note.permission, Const.PermView);
    this.NoteAdd = Util.isAllow(this.models.note.permission, Const.PermAdd);

    this.EmailList = Util.isAllow(this.models.email.permission, Const.PermView);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);

    this.SalesList = Util.isAllow(this.models.sales_order.permission, Const.PermView);
    this.SalesAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);

    this.ContactList = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);

    this.CloudCall = reactLocalStorage.getObject(Const.CloudCalling);
    this.CloudCall = this.CloudCall && Object.keys(this.CloudCall).length > 0 ? this.CloudCall : null;
    this.HidePhone = Util.isAllow(this.model.permission, Const.HideAllPhone);
    this.LeadPreviewRestrict = Util.isAllow(this.model.permission, Const.PermLeadPreviewRestrict);

    this.user.lead_preview = this.user.lead_preview ? this.user.lead_preview : 1;
    this.isGrowthPackageAndAbove = this.user?.package >= Const.PackageGrowth;
    this.designOptions = [
      { label: 'Tab View', value: LeadConst.TabView },
      { label: 'List View', value: LeadConst.ListView },
      { label: 'Compact View', value: LeadConst.CompactView },
    ];
    if(this.isGrowthPackageAndAbove) {
      this.designOptions.push({ label: 'Mordern View', value: LeadConst.ModernView })
    }
    this.designOption = this.designOptions.find(opt => opt.value === this.user.lead_preview);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.id !== parseInt(props.match.params.leadId)) {
      this.id = parseInt(props.match.params.leadId);
      let dummy = { ...this.state };
      if (dummy.call) { dummy.call.model_no = Const.Lead; dummy.call.model_id = this.id; }
      if (dummy.meeting) { dummy.meeting.model_no = Const.Lead; dummy.meeting.model_id = this.id; }
      if (dummy.document) { dummy.document.model_no = Const.Lead; dummy.document.model_id = this.id; }
      if (dummy.email) { dummy.email.model_no = Const.Lead; dummy.email.model_id = this.id; }
      if (dummy.sms) { dummy.sms.model_no = Const.Lead; dummy.sms.model_id = this.id; }
      this.setState({ ...dummy });
      LeadAPI.get(this.id, this.onReceived, this.onFail);
      const isNext = this.iItem !== 0 && this.lItem !== 0;
      this.editLink = `${this.base}/add-edit/${this.id}`
        + `${isNext ? `?indx=${this.iItem}&size=${this.lItem}` : ''}`;
    }
  }

  componentDidMount() { if (this.id !== 0) { LeadAPI.get(this.id, this.onReceived, this.onFail); } }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = (res) => {
    this.lead = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    LeadAPI.get(this.id, this.onReceived, this.onFail);
  };
  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.lead)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      LeadAPI.delete(this.lead.id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Lead deleted successfully', 'success');
    this.props.navigate('/lead');
  };

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    LeadAPI.get(this.id, this.onReceived, this.onFail);
  };

  onPrev = () => this.props.navigate(`/lead/next-prev/${this.iItem - 1}`);
  onNext = () => this.props.navigate(`/lead/next-prev/${this.iItem + 1}`);

  showDetails = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if (field === LeadConst.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  };
  showPopUp = (model, field) => {
    if (field === LeadConst.SalesOrder) {
      this.props.navigate(`/sales-order/add-edit/1/${this.id}/${model}`);
      return;
    }
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  };
  hidePopUp = () => this.setState({ ...this.state, popup: LeadConst.Refresh });
  redirectAddContact = () => this.props.navigate(`/contact/add-edit/${Const.Lead}/${this.id}/0`);
  addContact = contact => {
    this.setState({ inApiCall: true, popup: null });
    ContactAPI.addLeadContact(this.id, contact.value, this.onReceived, this.onFail);
  };
  onLoadContacts = contacts => {
    const options = contacts.map(cont => {
      return { label: Display.ModelName(cont), value: cont.id };
    });
    this.setState({ ...this.state, contacts: options });
  };

  onDesignChange = (option) => {
    this.designOption = option;
    reactLocalStorage.set(Const.LeadTheme, option.value);
    this.props.onModuleChanged();
  };

  onProperties = () => {
    const lead = this.lead;
    const filter = [];

    if (lead.min_budget && lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'in', value: `${lead.min_budget}~${lead.max_budget}`
    });
    else if (lead.min_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'start-with', value: `${lead.min_budget}~`
    });
    else if (lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'end-with', value: `~${lead.max_budget}`
    });

    if (lead.property_transaction) filter.push({
      field: 'property_transaction', type: 'select',
      condition: 'in', value: `${lead.property_transaction}`
    });

    if (lead.property_is) filter.push({
      field: 'property_is', type: 'select',
      condition: 'in', value: `${lead.property_is}`
    });

    if (lead.property_type) filter.push({
      field: 'property_type', type: 'select',
      condition: 'in', value: `${lead.property_type}`
    });
    if (lead.area) filter.push({
      field: 'area', type: 'select',
      condition: 'in', value: `${lead.area}`
    });
    this.props.navigate(`/property?filters=${JSON.stringify(filter)}`);
  };

  render() {
    let param = {};
    const EmailOpt = this.lead && this.lead.email_opt && this.lead.email_opt === Const.True;
    const SmsOpt = this.lead && this.lead.sms_opt && this.lead.sms_opt === Const.True;

    const CallPopUp = (this.CallAdd || this.CallUpdate) ?
      <CallPopup show={this.state.popup === LeadConst.Call} onHide={this.hidePopUp}
        call={this.state.call} reload={this.updateMater} model_no={Const.Lead} model_id={this.id} />
      : null;
    const MeetingPopUp = (this.MeetAdd || this.MeetUpdate) ?
      <MeetingPopup show={this.state.popup === LeadConst.Meeting} onHide={this.hidePopUp}
        meeting={this.state.meeting} contacts={this.state.contacts}
        reload={this.updateMater} model_no={Const.Lead} model_id={this.id} />
      : null;
    const DocumentPopUp = this.DocAdd ?
      <DocumentPopup show={this.state.popup === LeadConst.Document} onHide={this.hidePopUp}
        document={this.state.document}
        reload={this.updateMater} model_no={Const.Lead} model_id={this.id} />
      : null;
    const SmsPopUp = this.SmsAdd ?
      <SmsPopup show={this.state.popup === LeadConst.SMS} onHide={this.hidePopUp}
        data={this.lead} model={this.model}
        reload={this.updateMater} model_no={Const.Lead} model_id={this.id} />
      : null;
    const NotePopUp = this.NoteAdd ?
      <NotePopup show={this.state.popup === LeadConst.Note} onHide={this.hidePopUp} reload={this.updateMater}
        note={this.state.note} model={this.model} model_no={Const.Lead} model_id={this.id} />
      : null;
    const EmailPopUp = this.EmailAdd ?
      <EmailPopup show={this.state.popup === LeadConst.Email} onHide={this.hidePopUp}
        data={this.lead} model={this.model}
        reload={this.updateMater} model_no={Const.Lead} model_id={this.id} />
      : null;
    const LeadContactPopUp = this.ContactAdd ?
      <LeadContactPopup show={this.state.popup === LeadConst.Contact} onHide={this.hidePopUp}
        redirect={this.redirectAddContact} addContact={this.addContact} />
      : null;
    const CloudCallPopUp = this.CloudCall ?
      <CloudCallPopup show={this.state.popup === LeadConst.CloudCall} onHide={this.hidePopUp}
        call={this.state.CloudCall} addCall={this.showPopUp} data={this.lead} modelNo={Const.Lead} modelId={this.id} /> : null;

    const PrevButton = this.iItem > 1 ?
      <span className="buttons call" variant="primary" onClick={this.onPrev}>
        <FaChevronCircleLeft /> Prev</span> : null;
    const NextButton = this.iItem < this.lItem ?
      <span className="buttons next" variant="primary" onClick={this.onNext}>
        <FaChevronCircleRight /> Next</span> : null;
    const CallButton = this.CallAdd ?
      <span className="buttons call" variant="primary"
        onClick={() => this.showPopUp(null, LeadConst.Call)}><FaPhoneAlt /> {this.models.call.model_name}
      </span> : null;
    const MeetingButton = this.MeetAdd ?
      <span className="buttons meeting" variant="primary"
        onClick={() => this.showPopUp(null, LeadConst.Meeting)}><FaHandshake /> {this.models.meeting.model_name}
      </span> : null;
    const DocumentButton = this.DocAdd ?
      <span className="buttons junk" variant="primary"
        onClick={() => this.showPopUp(null, LeadConst.Document)}><FaFileAlt /> {this.models.document.model_name}
      </span> : null;
    const SmsButton = this.SmsAdd && !SmsOpt ?
      <span className="buttons sms" variant="primary"
        onClick={() => this.showPopUp({}, LeadConst.SMS)}><FaSms /> SMS
      </span> : null;
    const NoteButton = this.NoteAdd ?
      <span className="buttons note" variant="primary" onClick={() => this.showPopUp({}, LeadConst.Note)}>
        <FaClipboard /> {this.models.note.model_name}
      </span> : null;
    const EmailButton = this.EmailAdd && !EmailOpt ?
      <span className="buttons email" variant="primary"
        onClick={() => this.showPopUp({}, LeadConst.Email)}><FaRegEnvelope /> Email
      </span> : null;
    const SalesButton = this.SalesAdd ?
      <span className="buttons sales" variant="primary">
        <NavLink to={`/sales-order/add-edit/1/${this.id}/0`}><FaMoneyBillWave /> {this.models.sales_order.model_name}
        </NavLink>
      </span> : null;
    const ContactButton = this.ContactAdd ?
      <span className="buttons contact" variant="contact"
        onClick={() => this.showPopUp(null, LeadConst.Contact)}><FaUser /> Contact
      </span> : null;
    const UpdateButton = this.Update ?
      <span className="buttons update" variant="primary">
        <NavLink to={this.editLink}><FaPencilAlt /> Edit</NavLink>
      </span> : null;
    const DeleteButton = this.Delete ?
      <span className="buttons delete" onClick={this.onDelete}><FaTrash /> Delete</span> : null;
    const HistoryButton = <span className="buttons history" variant="primary">
      <NavLink to={`/lead/history/${this.id}`}><FaClock /> History</NavLink>
    </span>;
    const CloudCallButton = this.CloudCall ? <span className="buttons cloud" variant="primary"
      onClick={() => this.showPopUp(null, LeadConst.CloudCall)}><FaTty /> Cloud Call
    </span> : null;

    const PropertyButton = <span className="buttons fmt" onClick={this.onProperties}>
      <FaLayerGroup /> Find Matching Property(s)</span>;

    const CallList = this.CallList ?
      <InnerCallList id={this.id} type={Const.Lead} {...param} reload={this.updateMater}
        edit={this.showPopUp}
        cloud_call={this.CloudCall}
        onCloudeCall={this.showPopUp} /> : null;
    const MeetList = this.MeetList ?
      <InnerMeetingList id={this.id} type={Const.Lead} {...param} edit={this.showPopUp}
        reload={this.updateMater} /> : null;
    const DocList = this.DocList ?
      <PropertyDocTable id={this.id} type={Const.Lead} {...param} reload={this.updateMater} /> : null;
    // < InnerDocumentList id = { this.id } type = { Const.Lead } {...param; } reload = { this.updateMater } /> : null;
    const SmsList = this.SmsList ?
      <InnerSmsList id={this.id} type={Const.Lead} {...param} reload={this.updateMater} /> : null;
    const WhatsAppList = this.WhatsAppList ?
      <InnerWhatsAppList id={this.id} type={Const.Lead} {...param} reload={this.updateMater} /> : null;
    const NoteList = this.NoteAdd ?
      <InnerNoteList id={this.id} type={Const.Lead} {...param} reload={this.updateMater} edit={this.showPopUp} /> : null;
    const EmailList = this.EmailList ?
      <InnerEmailList id={this.id} type={Const.Lead} {...param} reload={this.updateMater} /> : null;
    const SalesList = this.SalesList ?
      <InnerSalesOrderList id={this.id} type={Const.Lead} {...param}
        reload={this.updateMater} show={this.showDetails} edit={this.showPopUp} /> : null;
    const ContactList = this.ContactList ?
      <InnerContactList id={this.id} type={Const.Lead} {...param} onLoad={this.onLoadContacts}
        reload={this.updateMater} show={this.showDetails} edit={this.showPopUp} /> : null;

    return (
      <section className="previewpage">
        <ApiUiController inApiCall={this.state.inApiCall}>
          {CallPopUp} {MeetingPopUp} {DocumentPopUp} {SmsPopUp} {EmailPopUp} {CloudCallPopUp} {NotePopUp}
          <WhatsAppPopup show={this.state.popup === LeadConst.WhatsApp} onHide={this.hidePopUp}
            data={this.lead} model={this.model} />
          {LeadContactPopUp}

          {!((this.lead?.responsible_person ?? '').includes(this.user?.user_id ?? 0)) && this.LeadPreviewRestrict ? (
            <RestrictedAccess />
          ) : (
            <div className="container-fluid">
              <div className="row lead-mt">
                <div className="col-md-4">
                  <div className="title_page"><h2>Lead - {this.lead && Display.ModelName(this.lead)}</h2></div>
                </div>
                <div className="col-md-8 lead-btns-col">
                  {this.lead && ViewController.ViewRestriction(this.Restrcited, this.lead) ?
                    <div className="row">
                      <div className="col-md-12">
                        <span className="action-btns-lg">
                          {PrevButton} {NextButton} {CallButton} {MeetingButton} {DocumentButton}
                          <span className="buttons whtsapp" variant="primary"
                            onClick={() => this.showPopUp({}, LeadConst.WhatsApp)}><FaWhatsapp /> WhatsApp
                          </span>
                          {EmailButton} {HistoryButton} {CloudCallButton}
                        </span>
                      </div>
                      <div className="col-md-12" style={{ margin: '30px 0 30px 0' }}>
                        <span className="action-btns-lg">
                          {NoteButton} {SmsButton} {SalesButton} {ContactButton} {UpdateButton} {DeleteButton}
                          {PropertyButton}
                        </span>
                      </div>
                      <div className="col-md-2">
                        <Select
                          value={this.designOption}
                          onChange={this.onDesignChange}
                          options={this.designOptions}
                          isClearable={false}
                        />
                      </div>
                    </div>
                    : null
                  }
                </div>
              </div>

              <div className="row tablesrow">
                <div className="col-md-12">
                  <LeadDetails model={this.model} lead={this.lead} leadName={this.lead && Display.ModelName(this.lead)} />
                  <LeadInformation model={this.model} lead={this.lead} />
                  {CallList} {MeetList} {DocList} {NoteList} {SmsList} {WhatsAppList} {EmailList} {SalesList} {ContactList}
                </div>
              </div>
            </div>
          ) }
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(LeadPreview);